export const RESULTS_TABLE_COLUMNS = ['Company', 'Opening Hours', 'Company Info', 'Website', 'Prefer to call directly?'];
